import { type Experiment } from '@/lib/firebase/types'

type ExperimentContext = Experiment | undefined

export const createExperimentsContext = (experiments: ExperimentContext[]) => {
  return Object.fromEntries(
    experiments.filter(Boolean).map((exp) => [exp?.trackingKey, exp?.group])
  )
}
